import { X } from 'lucide-react'
import Image from 'next/image'
import Link from 'next/link'
import { forwardRef, LegacyRef } from 'react'

interface HeaderMobileMenuProps {
  handleCloseClick: () => void
}

function HeaderMobileMenu(
  props: HeaderMobileMenuProps,
  ref: LegacyRef<HTMLDivElement>
) {
  return (
    <div
      ref={ref}
      className="fixed left-0 top-0 z-50 h-screen w-screen overflow-auto bg-brand-white-500 px-8 py-28 shadow-2xl"
    >
      <div className="mb-10 flex justify-between">
        <div className="flex flex-col gap-6">
          <p className="max-w-[180px] text-sm leading-5 text-brand-grayscale-12">
            Democratizamos o acesso à procedimentos de saúde.
          </p>
        </div>

        <X
          className="h-9 w-9 text-brand-green-primary-5"
          onClick={props.handleCloseClick}
        />
      </div>

      <div className="flex flex-col border-y border-solid border-[#EDEDED] py-10">
        <h3 className="mb-8 text-xl font-bold leading-6 text-brand-grayscale-12">
          Navegue
        </h3>

        <nav className="flex flex-col gap-6 text-brand-grayscale-8 transition hover:text-brand-grayscale-12">
          <Link href="/#home" onClick={props.handleCloseClick}>
            Home
          </Link>

          <Link href="/#about" onClick={props.handleCloseClick}>
            Sobre nós
          </Link>
          <Link href="/#how-it-works" onClick={props.handleCloseClick}>
            Como funciona
          </Link>
          <Link
            href="/#for-partner"
            className="text-brand-green-primary-5"
            onClick={props.handleCloseClick}
          >
            Para parceiros
          </Link>
          <Link
            href="/#testimonies-mobile"
            className="text-brand-orange-secondary-5 md:hidden"
            onClick={props.handleCloseClick}
          >
            Depoimentos
          </Link>

          <Link
            href="/#testimonies"
            className="hidden text-brand-orange-secondary-5 md:block"
            onClick={props.handleCloseClick}
          >
            Depoimentos
          </Link>

          <Link href="/#faq" onClick={props.handleCloseClick}>
            Dúvidas
          </Link>
        </nav>
      </div>
    </div>
  )
}

export default forwardRef(HeaderMobileMenu)
